import React from 'react';
import Scheduling from '../../components/Scheduling';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function SchedulingPage() {
  return (
    <PageLayout title="Agendamento" subtitle="Planejamento de publicações" primary={<Scheduling />} secondary={null} />
  );
}

export default SchedulingPage;
